import Videos from './Videos';
import InfoDialog from './components/InfoDialog.tsx';
import { useBranding } from '@/contexts/BrandingContext';
import { useAuth } from '@/contexts/AuthContext.tsx';
import ClientHelpCenter from '@/components/partner/ClientHelpCenter';

export default function HelpCenterTab() {
  const { branding, isWhiteLabel } = useBranding();
  const { profile } = useAuth();
  const showPartnerHelp = isWhiteLabel && !!branding.helpCenterContent && profile?.user_type === 'partner_client';

  if (showPartnerHelp) {
    return (
      <div className="p-4">
        <ClientHelpCenter />
      </div>
    );
  }

  return (
    <div className="p-4 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold">Help Center</h2>
          <p className="text-sm text-gray-600 mt-1">
            Get help, report issues, and request features through our support system.
          </p>
        </div>
        <InfoDialog />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">Quick Support</h3>
          <p className="text-sm text-gray-600 mb-4">
            Use the floating blue button in the bottom right corner of any page to submit tickets, report bugs, or request features.
          </p>
          <div className="space-y-2 text-sm">
            <div className="flex items-center">
              <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
              <span>Submit feature requests</span>
            </div>
            <div className="flex items-center">
              <div className="w-2 h-2 bg-red-500 rounded-full mr-3"></div>
              <span>Report bugs with screenshots</span>
            </div>
            <div className="flex items-center">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
              <span>Request new integrations</span>
            </div>
            <div className="flex items-center">
              <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
              <span>Share general feedback</span>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">Getting Help</h3>
          <p className="text-sm text-gray-600 mb-4">
            We're building a comprehensive knowledge base. For now, our team personally handles all support requests.
          </p>
          <div className="space-y-2 text-sm">
            <div className="flex items-center">
              <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
              <span>Personal support from our team</span>
            </div>
            <div className="flex items-center">
              <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
              <span>Quick response times</span>
            </div>
            <div className="flex items-center">
              <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
              <span>Direct communication</span>
            </div>
            <div className="flex items-center">
              <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3"></div>
              <span>Feature updates and notifications</span>
            </div>
          </div>
        </div>
      </div>
      <Videos />
    </div>
  );
}
